import React, { useState } from "react";
import axios from "axios";
import { link } from '@fiskil/link'; // Import the Fiskil SDK
import { useAuth } from "../../../../../AuthProvider";
import { baseUrl_SPB } from "../../../../../BaseUrl";

export default function FiskilConnectScreen() {
  const [loading, setLoading] = useState(false);
  const authContext = useAuth();

  const handleConnect = async () => {
    try {
      setLoading(true);
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authContext.token
      };

      // 1. Ask Spring Boot backend to create a Fiskil Auth Session
      const res = await axios.post(`${baseUrl_SPB}/api/v1/fiskil/connect`, {}, { headers });
      
      // Assume backend returns an object with { authSessionId: "..." }
      const { authSessionId } = res.data; 

      // 2. Launch the hosted Fiskil Link UI overlay flow
      const flow = link(authSessionId);
      
      // 3. Await user authorization outcome
      const result = await flow;
      
      if (result.consentID) {
        console.log("Consent Success! Consent ID:", result.consentID);
        
        // 4. Save consent ID to your backend database mapping for this company
        await axios.post(`${baseUrl_SPB}/api/v1/fiskil/save-consent`, {
          consentId: result.consentID,
          companyId: authContext.additionalUserInfo.companyId // adjustment based on setup
        }, { headers });

        alert("Bank connected successfully!");
      }
    } catch (err) {
      console.error("Link Flow Failed or Cancelled:", err);
      alert(`Connection failed: ${err.code || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Connect Bank (Fiskil)</h2>
      {authContext.additionalUserInfo.phone && (
        <button onClick={handleConnect} disabled={loading}>
          {loading ? "Connecting securely..." : "Connect Bank Account"}
        </button>
      )}
    </div>
  );
}